import React, { useMemo } from 'react';
import { Text } from '@chakra-ui/react';
import { toZonedTime } from 'date-fns-tz';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useAppVisibility } from 'clipsal-cortex-utils/src/hooks/use-app-visibility';

import { getFormattedTime } from '../../features/account/settings/settings-helpers';
import { useGetInverterLiveDataQuery } from '../../features/site/live-data/liveDataApi';
import { selectSite } from '../../features/site/siteSlice';
import { IS_DEMO_LOGIN } from '../constants';
import { useSiteCapabilityCheck } from '../hooks/use-site-capability-check';

// This component displays the last updated time of Saturn live data if it is available.
export function SaturnLastUpdated() {
  const { site_id: siteId, timezone } = useSelector(selectSite);
  const { siteHasInverter } = useSiteCapabilityCheck();

  const isAppVisible = useAppVisibility() || IS_DEMO_LOGIN; // No need to skip API calls in demo mode
  const { data: liveInverterData } = useGetInverterLiveDataQuery(siteId, {
    pollingInterval: 5000,
    skip: !siteHasInverter || !isAppVisible,
  });
  const { t } = useTranslation();

  const lastUpdatedDate = useMemo(
    () => (liveInverterData?.last_updated ? toZonedTime(liveInverterData.last_updated, timezone) : undefined),
    [liveInverterData?.last_updated, timezone]
  );

  const lastUpdatedString = useMemo(
    () => (lastUpdatedDate ? getFormattedTime(lastUpdatedDate) : ''),
    [lastUpdatedDate]
  );

  return (
    <Text
      fontSize="0.8rem"
      hidden={!lastUpdatedDate}
      textAlign="center"
      color="customGrey.400"
      data-testid="last-updated"
    >
      [{t('Common.last updated')}: {lastUpdatedString}]
    </Text>
  );
}
